// Thresholds for dynamic search icon
export const SINGLE_RESULT_CHAR_THRESHOLD = 3;
export const NATURAL_LANGUAGE_WORD_THRESHOLD = 3;

// Display config for chips rendered in the search-filter strip for non-entity
// filters (dateRange, tags, genres, instruments, aggregate)
export const SEARCH_CHIP_CONFIG = {
  dateRange: { iconName: "tag", displayName: "Date Range" },
  tags: { iconName: "tag", displayName: "Tag" },
  genres: { iconName: "tag", displayName: "Genre" },
  instruments: { iconName: "instrument", displayName: "Instrument" },
  aggregate: { iconName: "quick_filter", displayName: "Quick Filters" }
};
